import { IMockProps } from '_core/types';
import { ENDPOINT_API_PATH } from '../Definitions/DependentsDef';

//responsável maior de idade consultando contas associadas
const autoGenerateSuccessConsultingMinor = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {
        isLegalGuardian: true,
        accounts: [
          {
            memberNumber: '730847633',
            name: 'Nome do filho ou outra conta associada',
          },
        ],
      },
    },
  };
  return validateSuccess;
};

//menor de idade consultando responsavel legal (maior de idade)
const autoGenerateSuccessConsultingLegalGuardian = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {
        isLegalGuardian: false,
        accounts: [
          {
            memberNumber: '730847633',
            name: 'Nome do responsável',
          },
        ],
      },
    },
  };
  return validateSuccess;
};

const generatedSuccessMocks = [
  autoGenerateSuccessConsultingMinor(),
  autoGenerateSuccessConsultingLegalGuardian(),
];

const GetDependents = [...generatedSuccessMocks];
export default GetDependents;
